export default __webpack_public_path__ + "static/logo-0db72ce7f57bff26cdf86899a07c93d3.svg";